import { backend_api_v2 } from '/src/utils/apiv2'
import bus from '/src/utils/event_bus'
import { useAppStore } from "/src/stores/app"

export const COMPANY_PR_ALL = {
    uuid: "all",
    name: "Company Wide",
    phases: [],
    meta: {},
}



export function loadDesignFactory(obj_name, url_key) {
    function loadDesign(d_uuid) {
        const app_store = useAppStore()
        app_store.pushLoading("viewer")
        return backend_api_v2.get(`/${url_key}/${d_uuid}/`)
            .then(({ data }) => {
                this['set' + obj_name](data)
                app_store.popLoading("viewer")
            })
            .catch(e => {
                app_store.popLoading("viewer")
                console.log(`Cant load design: ${e}`)
            })
    }
    return loadDesign
}

// The unit each loader was last asked for, so a late failure for a unit the
// route has already left cannot clear the one it is on now.
const LAST_ACTUAL = {}

export function loadActualAndItsDesignFactory(obj_name, obj_name_d, url_key) {
    function loadDesignFromActual(a_uuid) {
        const app_store = useAppStore()
        app_store.pushLoading("viewer")
        LAST_ACTUAL[obj_name] = a_uuid
        return backend_api_v2.get(`/${url_key}/${a_uuid}/`)
            .then(({ data }) => {
                this['set' + obj_name](data)
                this.clearRefusal(a_uuid)
                app_store.popLoading("viewer")
                return this["load" + obj_name_d](data.design)
            })
            .catch(e => {
                app_store.popLoading("viewer")
                console.log(`Cant load ${obj_name.toLowerCase()}: ${e}`)
                if (LAST_ACTUAL[obj_name] != a_uuid) return
                // The address names this unit: keeping the previous one on
                // screen, with its checklist, would act on the wrong panel.
                this['set' + obj_name](null)
                this['set' + obj_name_d](null)
                bus.emit("events/selected/actualRefused")
                this.noteRefusal(a_uuid, obj_name.toLowerCase(), e)
            })
    }
    return loadDesignFromActual
}
